<template>
  <div class='institutional-qnr-thanks-view p-6 is-flex-center'>
    <div class='is-flex-col page-width p-6 has-background-white border-rad-1'>

      <header class='mb-2 is-flex align-center justify-between'>
        <h1 class='is-size-2 bold'>Thank you {{context.name}}</h1>
        <div><i class='fa fa-check-circle ml-3 has-text-success is-size-3'></i></div>
      </header>

      <p>Thank you for completing this questionnaire. <span class='weight-bold'>{{context.advisor_name}}</span> will get in touch in a few weeks time.</p>

      <router-link :to="{ name: 'institutional-qnr-intro' }">
        <button class='button is-primary mt-4'>
          Retake Questionnaire
        </button>
      </router-link>
    </div>
  </div>
</template>


<script>
import mockQnrResponseData from './mockQnrResponseData';
import { postQuestionnaireResponses } from '@frontend/api/questionnaireApi';

export default {
  name: 'institutional-qnr-thanks-view',
  components: { /* Subcomponents */ },
  props: [ 'sections', 'context' ],
  data() {
    return { /* Local variables */ };
  },
  beforeCreate() {},
  async created() {
    /*
    console.log('SECTIONS', this.sections);
    const submitPayload = {
      'answers': {},
      'provides_values': false,
    };
    this.sections.forEach(section => {
      section.questions.forEach((question) => {
        submitPayload.answers[question.slug] = question.answer;
      });
    })
    console.log('This is the payload')
    console.log(submitPayload)
    // const res = (await postQuestionnaireResponses('inst-qnr-v1', submitPayload, this.$root.$data.csrfToken)).data;
    console.log('RES', res);
    */
  },
  mounted() {},
  updated() {},
  computed: { /*
      Creates a new property
      Updates when any dependant property changes */
  },
  watch: { /*
      Watches an existing property
      Only runs when the watched property changes */
  },
  methods: {},
};
</script>


<style scoped>

</style>
